var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback-quote"
  }, [_c('div', {
    staticClass: "feedback-review"
  }, [_c('p', [_c('q', [_vm._v("Curabitur quis nisl in leo euismod venenatis eu in diam. Etiam auctor diam pellentesque lectus vehicula mattis.")]), _vm._v(" Nulla ac massa at dolor condimentum\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "feedback-author"
  }, [_vm._v("\n        Jhon Doe\n    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45dde3b1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/feedback-quote/feedback-quote.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-45dde3b1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/feedback-quote/feedback-quote.vue
// module chunks = index